module.exports = __webpack_public_path__ + "img/batch@2x.199849e3.png";